import Vue from "vue";

// vue filter
Vue.filter("sumTwoNumber", (number1: any, number2: any) => parseInt(number1) + parseInt(number2));
Vue.filter("uppercase", (value: string) => value ? value.toUpperCase() : value);
Vue.filter("lowercase", (value: string) => value ? value.toLowerCase() : value);
Vue.filter("capitalize", (value: string) => value ? value.charAt(0).toUpperCase() + value.slice(1) : value);